import { Main, ViewButton } from 'components/ActionStyles/ActionStyles'
import { getPromotion } from 'modules/Roles/actions'
import React from 'react'
import { useDispatch } from 'react-redux'

const ViewActions = ({ student_id, candidateLoading, studentDetailsAPI }) => {
  const dispatch = new useDispatch()

  const handleClick = () => {
    studentDetailsAPI(student_id)
    dispatch(getPromotion(student_id))
  }

  return (
    <Main key={student_id}>
      <ViewButton
        key={student_id}
        onClick={handleClick}
        height="32px"
        text={'View'}
        loading={candidateLoading}
      />
    </Main>
  )
}

export default ViewActions
